/* @ngInject */
class Alert {
	constructor(PusherService, toastr) {
		this.PusherService = PusherService;
		this.toastr        = toastr;
		this.callback      = (channelName, event, data) => {
			this.processAlert(channelName, event, data)
		};
	}

	init() {
		this.on();
	}

	on() {
		this.PusherService.on(null, 'alert', this.callback);
	}

	off() {
		this.PusherService.off(null, 'alert', this.callback);
	}

	processAlert(channelName, event, data) {
		const type    = data.type;
		const message = data.message;
		const title   = data.title;

		switch (type) {
			case 'success': {
				this.toastr.success(message, title);

				break;
			}

			case 'warning': {
				this.toastr.warning(message, title);

				break;
			}

			case 'error': {
				this.toastr.error(message, title);

				break;
			}

			case 'info':
			default: {
				this.toastr.info(message, title);

				break;
			}
		}
	}
}

export default Alert;


// WEBPACK FOOTER //
// ./src/js/services/alert/index.js